import { render, staticRenderFns } from "./xlsyList.vue?vue&type=template&id=4c3fdfa4&scoped=true&"
import script from "./xlsyList.vue?vue&type=script&lang=js&"
export * from "./xlsyList.vue?vue&type=script&lang=js&"
import style0 from "./xlsyList.vue?vue&type=style&index=0&id=4c3fdfa4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3fdfa4",
  null
  
)

export default component.exports